$(() => {
  let isSliderInitialized = false;
  function initMarqueeSlider() {
    const wrapper = $('.static-logo-section-mobile .logos-wrapper');
    if (window.innerWidth <= 767) {
      if (!isSliderInitialized) {
        wrapper.slick({
          speed: 5000,
          autoplay: true,
          autoplaySpeed: 0,
          cssEase: 'linear', 
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          arrows: false,
          dots: false,
          pauseOnHover: false,
          pauseOnFocus: false,
        });

        isSliderInitialized = true;
      }
    } else {
      if (isSliderInitialized) {
        wrapper.slick('unslick');
        isSliderInitialized = false;
      }
    }
  }

  initMarqueeSlider();
  $(window).on('resize', initMarqueeSlider);
});
